// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zHealthDto = z.object({
    status: z.enum(['ok', 'degraded']),
    checks: z.record(z.string(), z.enum(['ok', 'error']))
});

export const zGraphUserDto = z.object({
    id: z.string(),
    displayName: z.string(),
    userPrincipalName: z.string(),
    userType: z.string().nullable().default(null),
    accountEnabled: z.boolean().nullable().default(null),
    givenName: z.string().nullable().default(null),
    surname: z.string().nullable().default(null),
    jobTitle: z.string().nullable().default(null),
    department: z.string().nullable().default(null),
    officeLocation: z.string().nullable().default(null),
    mail: z.string().nullable().default(null),
    mobilePhone: z.string().nullable().default(null),
    employeeId: z.string().nullable().default(null),
    companyName: z.string().nullable().default(null),
    onPremisesDistinguishedName: z.string().nullable().default(null)
});

export const zPhotoUploadAckDto = z.object({
    status: z.enum(['pending']).optional(),
    pendingId: z.string().optional(),
    message: z.string().optional()
});

export const zPendingPhotoResponseDto = z.object({
    pending: z.object({
        id: z.string(),
        userOid: z.string(),
        userUpn: z.string().nullable(),
        userName: z.string().nullable(),
        submittedAt: z.string(),
        mimeType: z.string(),
        sizeBytes: z.number(),
        thumbnailUrl: z.string(),
        rejectedAt: z.string().nullish(),
        rejectionReason: z.string().nullish(),
        submittedByOid: z.string().nullish(),
        submittedByUpn: z.string().nullish(),
        submittedByName: z.string().nullish()
    }).nullable()
});

export const zPendingPhotoDto = z.object({
    id: z.string(),
    userOid: z.string(),
    userUpn: z.string().nullable(),
    userName: z.string().nullable(),
    submittedAt: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number(),
    thumbnailUrl: z.string(),
    rejectedAt: z.string().nullish(),
    rejectionReason: z.string().nullish(),
    submittedByOid: z.string().nullish(),
    submittedByUpn: z.string().nullish(),
    submittedByName: z.string().nullish()
});

export const zMessageDto = z.object({
    message: z.string()
});

export const zSweepAckDto = z.object({
    jobId: z.string(),
    message: z.string()
});

export const zRejectPendingDto = z.object({
    reason: z.string().max(500).optional()
});

export const zLuccaStatusDto = z.object({
    enabled: z.boolean()
});

export const zLuccaFieldsResponseDto = z.object({
    fields: z.array(z.object({
        key: z.string(),
        type: z.enum([
            'string',
            'boolean',
            'integer',
            'number'
        ]),
        format: z.string().optional()
    }))
});

export const zPhotoUrlsRequestDto = z.object({
    logins: z.array(z.string().min(3).max(320)).min(1).max(500)
});

export const zPhotoUrlResultDto = z.object({
    login: z.string(),
    url: z.string().nullable()
});

export const zIseeStatusDto = z.object({
    enabled: z.boolean()
});

export const zIseeFieldsResponseDto = z.object({
    fields: z.array(z.object({
        key: z.string(),
        type: z.enum([
            'string',
            'boolean',
            'integer',
            'number'
        ]),
        format: z.string().optional()
    }))
});

export const zIseeSessionTreeDto = z.record(z.string(), z.record(z.string(), z.record(z.string(), z.record(z.string(), z.object({
    admStatus: z.array(z.string()),
    speciality: z.array(z.string()),
    sessions: z.array(z.object({
        school: z.string(),
        program: z.string(),
        promo: z.string(),
        campus: z.string(),
        section: z.string()
    }))
})))));

export const zIseeStudentsResponseDto = z.object({
    count: z.number(),
    students: z.array(z.object({
        login: z.string(),
        firstname: z.string(),
        lastname: z.string(),
        section: z.string(),
        campus: z.string(),
        promo: z.string(),
        admStatus: z.string(),
        speciality: z.string(),
        year: z.string()
    }))
});

export const zBatchValidateRequestDto = z.object({
    upns: z.array(z.string()).min(1).max(500)
});

export const zBatchValidationResultDto = z.object({
    upn: z.string(),
    found: z.boolean(),
    displayName: z.string().optional(),
    userId: z.string().optional(),
    onPremisesDistinguishedName: z.string().nullish(),
    isEmployee: z.boolean().optional()
});

export const zBatchUploadResultDto = z.object({
    filename: z.string(),
    login: z.string(),
    userId: z.string().optional(),
    displayName: z.string().optional(),
    status: z.enum([
        'success',
        'pending',
        'not_found',
        'skipped',
        'error'
    ]),
    message: z.string().optional(),
    code: z.string().optional(),
    pendingId: z.string().optional()
});

export const zPreflightResponseDto = z.object({
    resolveBatchId: z.string()
});

export const zGenerateFromLuccaDto = z.object({
    templateId: z.string().min(1),
    outputFormat: z.enum(['zip', 'pdf']).optional(),
    sides: z.enum([
        'both',
        'front',
        'back'
    ]).optional(),
    sortBy: z.string().min(1).optional(),
    logins: z.array(z.string()).min(1),
    values: z.record(z.string(), z.string()).optional()
});

export const zCardPreflightRecapDto = z.object({
    total: z.number(),
    valid: z.array(z.object({
        upn: z.string(),
        displayName: z.string().optional()
    })),
    errors: z.array(z.object({
        upn: z.string(),
        displayName: z.string().optional(),
        status: z.enum([
            'valid',
            'error',
            'not_found'
        ]),
        message: z.string().optional(),
        messageCode: z.enum([
            'guest',
            'account_not_found',
            'photo_missing',
            'photo_type_unsupported',
            'missing_fields',
            'unresolved_vars',
            'lucca_not_found',
            'not_enrolled'
        ]).optional(),
        messageParams: z.record(z.string(), z.string()).optional()
    }))
});

export const zPreflightDiscardedDto = z.object({
    discarded: z.boolean()
});

export const zRenderCancelledDto = z.object({
    cancelled: z.boolean()
});

export const zCommitCardsDto = z.object({
    resolveBatchId: z.string().min(1),
    outputFormat: z.enum(['zip', 'pdf']).optional()
});

export const zGenerateCardsResponseDto = z.object({
    jobId: z.string(),
    deduplicated: z.boolean()
});

export const zCardJobSummaryDto = z.object({
    jobId: z.string(),
    createdAt: z.number(),
    total: z.number(),
    done: z.number(),
    status: z.enum([
        'queued',
        'processing',
        'review',
        'done',
        'error'
    ]),
    kind: z.enum(['resolve', 'render']),
    downloadAvailable: z.boolean(),
    queuePosition: z.number().nullable()
});

/**
 * `event: progress` — one card processed, or a bar-sync (no `result`).
 */
export const zCardStreamProgressDto = z.object({
    done: z.number(),
    total: z.number(),
    current: z.string().optional(),
    result: z.object({
        upn: z.string(),
        displayName: z.string().optional(),
        status: z.enum([
            'success',
            'error',
            'not_found'
        ]),
        s3Key: z.string().optional(),
        backS3Key: z.string().optional(),
        sortRank: z.number().optional(),
        message: z.string().optional(),
        messageCode: z.enum([
            'guest',
            'account_not_found',
            'photo_missing',
            'photo_type_unsupported',
            'missing_fields',
            'unresolved_vars',
            'lucca_not_found',
            'not_enrolled'
        ]).optional(),
        messageParams: z.record(z.string(), z.string()).optional()
    }).optional()
});

/**
 * `event: throttled` — an upstream 429 paused the batch until `resumeAt` (epoch ms). Not terminal.
 */
export const zCardStreamThrottledDto = z.object({
    service: z.string(),
    resumeAt: z.number()
});

/**
 * `event: finalizing` — every card is rendered, the batch is assembling its zip/pdf. Not terminal.
 */
export const zCardStreamFinalizingDto = z.record(z.string(), z.never());

/**
 * `event: done` — the batch finished. Terminal.
 */
export const zCardStreamDoneDto = z.object({
    jobId: z.string()
});

/**
 * `event: error` (the batch failed, terminal) or `event: timeout` (the server capped the stream lifetime — reconnect).
 */
export const zCardStreamMessageDto = z.object({
    message: z.string()
});

export const zCardStreamEventDto = z.union([
    zCardStreamProgressDto,
    zCardStreamThrottledDto,
    zCardStreamFinalizingDto,
    zCardStreamDoneDto,
    zCardStreamMessageDto
]);

export const zCardPreviewUrlDto = z.object({
    url: z.string(),
    backUrl: z.string().optional()
});

export const zCardPreviewUrlsBulkDto = z.object({
    previews: z.record(z.string(), z.object({
        url: z.string(),
        backUrl: z.string().optional()
    }))
});

export const zCardDownloadUrlDto = z.object({
    url: z.string()
});

export const zCardBatchDto = z.object({
    id: z.string(),
    jobId: z.string(),
    actorOid: z.string(),
    actorUpn: z.string().nullable(),
    actorName: z.string().nullable(),
    templateName: z.string(),
    outputFormat: z.string(),
    rowCount: z.number(),
    identifiers: z.array(z.string()),
    s3Key: z.string().nullish(),
    results: z.record(z.string(), z.enum([
        'ok',
        'notFound',
        'error'
    ])).nullish(),
    expiresAt: z.string().nullable(),
    createdAt: z.string(),
    completedAt: z.string().nullish(),
    stats: z.object({
        success: z.number(),
        error: z.number(),
        notFound: z.number()
    }).nullish(),
    status: z.enum([
        'processing',
        'done',
        'failed'
    ]).optional(),
    failedReason: z.string().nullish()
});

export const zAdminMeDto = z.object({
    oid: z.string(),
    upn: z.string().nullish(),
    name: z.string().nullish(),
    role: z.string().nullable()
});

export const zAppUsersPageDto = z.object({
    total: z.number(),
    page: z.number(),
    limit: z.number(),
    users: z.array(z.object({
        id: z.string(),
        oid: z.string(),
        upn: z.string().nullable(),
        displayName: z.string().nullable(),
        role: z.string().nullable(),
        active: z.boolean(),
        externalId: z.string().nullish(),
        createdAt: z.string(),
        updatedAt: z.string()
    }))
});

export const zCreateUserDto = z.object({
    upn: z.string().min(3).max(320),
    role: z.enum([
        'user',
        'operator',
        'admin'
    ]).nullish()
});

export const zAppUserDto = z.object({
    id: z.string(),
    oid: z.string(),
    upn: z.string().nullable(),
    displayName: z.string().nullable(),
    role: z.string().nullable(),
    active: z.boolean(),
    externalId: z.string().nullish(),
    createdAt: z.string(),
    updatedAt: z.string()
});

export const zUpdateUserDto = z.object({
    role: z.enum([
        'user',
        'operator',
        'admin'
    ]).nullish(),
    active: z.boolean().optional()
});

export const zAuditLogsPageDto = z.object({
    total: z.number(),
    page: z.number(),
    limit: z.number(),
    logs: z.array(z.object({
        id: z.number(),
        actorOid: z.string(),
        actorName: z.string().nullable(),
        actorUpn: z.string().nullable(),
        action: z.string(),
        targetId: z.string().nullable(),
        details: z.record(z.string(), z.unknown()).nullable(),
        ip: z.string().nullable(),
        createdAt: z.string()
    }))
});

export const zCardSideDto = z.object({
    id: z.string(),
    name: z.string(),
    variables: z.array(z.string()),
    svgUrl: z.string().optional(),
    createdBy: z.string(),
    createdAt: z.string(),
    updatedAt: z.string().optional()
});

export const zSvgBodyDto = z.object({
    svg: z.string()
});

export const zRenameSideDto = z.object({
    name: z.string().min(1)
});

export const zDeletedFlagDto = z.object({
    deleted: z.boolean()
});

export const zCardTemplateDto = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    active: z.boolean(),
    type: z.enum([
        'student',
        'employee',
        'other'
    ]),
    createdBy: z.string(),
    frontSideId: z.string().nullable(),
    backSideId: z.string().nullable(),
    defaults: z.record(z.string(), z.string()).nullable(),
    frontSide: z.object({
        id: z.string(),
        name: z.string()
    }).nullable(),
    backSide: z.object({
        id: z.string(),
        name: z.string()
    }).nullable(),
    createdAt: z.string(),
    updatedAt: z.string()
});

export const zCardTemplateSvgsDto = z.object({
    frontSvg: z.string(),
    name: z.string(),
    backSvg: z.string().nullable(),
    defaults: z.record(z.string(), z.string())
});

export const zCreateTemplateDto = z.object({
    name: z.string().min(1).max(100),
    description: z.string().max(500).optional(),
    type: z.enum([
        'student',
        'employee',
        'other'
    ]).optional(),
    frontSideId: z.string().optional(),
    backSideId: z.string().optional(),
    defaults: z.record(z.string(), z.string()).optional()
});

export const zUpdateTemplateDto = z.object({
    name: z.string().min(1).max(100).optional(),
    type: z.enum([
        'student',
        'employee',
        'other'
    ]).optional(),
    description: z.string().max(500).optional(),
    active: z.boolean().optional(),
    frontSideId: z.string().nullish(),
    backSideId: z.string().nullish(),
    defaults: z.record(z.string(), z.string()).optional(),
    svg: z.string().optional()
});

export const zDashboardDto = z.object({
    services: z.object({
        db: z.enum(['ok', 'error']),
        redis: z.enum(['ok', 'error']),
        s3: z.enum(['ok', 'error']),
        worker: z.enum(['ok', 'idle']),
        workerCount: z.number()
    }),
    queue: z.object({
        generate: z.record(z.string(), z.number()).nullable(),
        finalize: z.record(z.string(), z.number()).nullable()
    }),
    stats: z.object({
        users: z.number().nullable(),
        templates: z.number().nullable()
    })
});

export const zHealthControllerCheckResponse = zHealthDto;

export const zUsersControllerSearchUsersQuery = z.object({
    q: z.string()
});

export const zUsersControllerSearchUsersResponse = z.array(zGraphUserDto);

export const zUsersControllerDeleteUserPhotoPath = z.object({
    userId: z.string()
});

export const zUsersControllerDeleteUserPhotoQuery = z.object({
    targetUpn: z.string().optional(),
    targetName: z.string().optional()
});

export const zUsersControllerDeleteUserPhotoResponse = z.void();

export const zUsersControllerGetUserPhotoPath = z.object({
    userId: z.string()
});

export const zUsersControllerGetUserPhotoResponse = z.string();

export const zUsersControllerUploadUserPhotoBody = z.object({
    photo: z.string()
});

export const zUsersControllerUploadUserPhotoPath = z.object({
    userId: z.string()
});

export const zUsersControllerUploadUserPhotoQuery = z.object({
    targetUpn: z.string().optional(),
    targetName: z.string().optional()
});

export const zUsersControllerUploadUserPhotoResponse = zPhotoUploadAckDto;

export const zUsersControllerCancelOwnPendingResponse = z.void();

export const zUsersControllerGetOwnPendingResponse = zPendingPhotoResponseDto;

export const zUsersControllerListPendingResponse = z.array(zPendingPhotoDto);

export const zUsersControllerGetPendingByUserPath = z.object({
    userId: z.string()
});

export const zUsersControllerGetPendingByUserResponse = zPendingPhotoResponseDto;

export const zUsersControllerApprovePendingPath = z.object({
    id: z.string()
});

export const zUsersControllerApprovePendingResponse = zMessageDto;

export const zUsersControllerTriggerSweepResponse = zSweepAckDto;

export const zUsersControllerRejectPendingBody = zRejectPendingDto;

export const zUsersControllerRejectPendingPath = z.object({
    id: z.string()
});

export const zUsersControllerRejectPendingResponse = zMessageDto;

export const zUsersControllerGetUserPath = z.object({
    userId: z.string()
});

export const zUsersControllerGetUserResponse = zGraphUserDto;

export const zLuccaControllerGetStatusResponse = zLuccaStatusDto;

export const zLuccaControllerGetFieldsResponse = zLuccaFieldsResponseDto;

export const zPhotosControllerExportPhotosQuery = z.object({
    school: z.string().min(1),
    program: z.string().min(1),
    cohort: z.string().min(1),
    campus: z.string().optional(),
    admStatus: z.string().optional(),
    section: z.string().optional(),
    speciality: z.string().optional()
});

export const zPhotosControllerExportPhotosResponse = z.string();

export const zPhotosControllerGetPhotoUrlsBody = zPhotoUrlsRequestDto;

export const zPhotosControllerGetPhotoUrlsHeaders = z.object({
    'x-api-secret': z.string().optional()
});

export const zPhotosControllerGetPhotoUrlsResponse = z.array(zPhotoUrlResultDto);

export const zIseeControllerGetStatusResponse = zIseeStatusDto;

export const zIseeControllerGetFieldsResponse = zIseeFieldsResponseDto;

export const zIseeControllerGetSessionsResponse = zIseeSessionTreeDto;

export const zIseeControllerGetStudentsQuery = z.object({
    school: z.string().min(1),
    program: z.string().min(1),
    cohort: z.string().min(1),
    campus: z.string().optional(),
    admStatus: z.string().optional(),
    section: z.string().optional(),
    speciality: z.string().optional()
});

export const zIseeControllerGetStudentsResponse = zIseeStudentsResponseDto;

export const zBatchControllerValidateBody = zBatchValidateRequestDto;

export const zBatchControllerValidateResponse = z.array(zBatchValidationResultDto);

export const zBatchControllerUploadBody = z.object({
    photo: z.array(z.string())
});

export const zBatchControllerUploadResponse = z.array(zBatchUploadResultDto);

export const zCardsControllerPreflightCsvBody = z.object({
    csv: z.string(),
    template: z.string(),
    templateId: z.string().optional(),
    outputFormat: z.enum(['zip', 'pdf']).optional(),
    sides: z.enum([
        'both',
        'front',
        'back'
    ]).optional(),
    sortBy: z.string().optional(),
    delimiter: z.enum([
        ',',
        ';',
        '\t',
        '|'
    ]).optional()
});

export const zCardsControllerPreflightCsvResponse = zPreflightResponseDto;

export const zCardsControllerGenerateFromIseeBody = z.object({
    school: z.string().optional(),
    program: z.string().optional(),
    cohort: z.string().optional(),
    campus: z.string().optional(),
    admStatus: z.string().optional(),
    section: z.string().optional(),
    speciality: z.string().optional(),
    logins: z.string().optional(),
    templateId: z.string().optional(),
    template: z.string().optional(),
    values: z.string().optional(),
    outputFormat: z.enum(['zip', 'pdf']).optional(),
    sides: z.enum([
        'both',
        'front',
        'back'
    ]).optional(),
    sortBy: z.string().optional()
});

export const zCardsControllerGenerateFromIseeResponse = zPreflightResponseDto;

export const zCardsControllerPreflightLuccaBody = zGenerateFromLuccaDto;

export const zCardsControllerPreflightLuccaResponse = zPreflightResponseDto;

export const zCardsControllerRecapPath = z.object({
    id: z.string()
});

export const zCardsControllerRecapResponse = zCardPreflightRecapDto;

export const zCardsControllerDiscardPreflightPath = z.object({
    id: z.string()
});

export const zCardsControllerDiscardPreflightResponse = zPreflightDiscardedDto;

export const zCardsControllerCancelRenderPath = z.object({
    jobId: z.string()
});

export const zCardsControllerCancelRenderResponse = zRenderCancelledDto;

export const zCardsControllerCommitBody = zCommitCardsDto;

export const zCardsControllerCommitResponse = zGenerateCardsResponseDto;

export const zCardsControllerGetJobsResponse = z.array(zCardJobSummaryDto);

export const zCardsControllerStreamPath = z.object({
    jobId: z.string()
});

/**
 * Server-sent events `progress`, `throttled`, `done`, `error`, `timeout`; `data` is JSON.
 */
export const zCardsControllerStreamResponse = zCardStreamEventDto;

export const zCardsControllerPreviewPath = z.object({
    jobId: z.string(),
    upn: z.string()
});

export const zCardsControllerPreviewResponse = zCardPreviewUrlDto;

export const zCardsControllerPreviewsPath = z.object({
    jobId: z.string()
});

export const zCardsControllerPreviewsResponse = zCardPreviewUrlsBulkDto;

export const zCardsControllerDownloadPath = z.object({
    jobId: z.string()
});

export const zCardsControllerDownloadResponse = zCardDownloadUrlDto;

export const zCardsControllerPdfPath = z.object({
    jobId: z.string()
});

export const zCardsControllerPdfResponse = zCardDownloadUrlDto;

export const zCardsControllerHistoryResponse = z.array(zCardBatchDto);

export const zCardsControllerHistoryDetailPath = z.object({
    batchId: z.string()
});

export const zCardsControllerHistoryDetailResponse = zCardBatchDto;

export const zCardsControllerHistoryDownloadPath = z.object({
    batchId: z.string()
});

export const zCardsControllerHistoryDownloadResponse = zCardDownloadUrlDto;

export const zAdminControllerGetMeResponse = zAdminMeDto;

export const zAdminControllerGetUsersQuery = z.object({
    q: z.string().optional(),
    sortBy: z.string().optional(),
    sortDir: z.string().optional(),
    page: z.int().gt(0).lte(9007199254740991).optional(),
    limit: z.int().gt(0).lte(9007199254740991).optional()
});

export const zAdminControllerGetUsersResponse = zAppUsersPageDto;

export const zAdminControllerCreateUserBody = zCreateUserDto;

export const zAdminControllerCreateUserResponse = zAppUserDto;

export const zAdminControllerUpdateUserBody = zUpdateUserDto;

export const zAdminControllerUpdateUserPath = z.object({
    oid: z.string()
});

export const zAdminControllerUpdateUserResponse = zAppUserDto;

export const zAdminControllerGetLogsQuery = z.object({
    actorOid: z.string().optional(),
    targetId: z.string().optional(),
    targetUpn: z.string().optional(),
    action: z.string().optional(),
    from: z.string().optional(),
    to: z.string().optional(),
    page: z.int().gt(0).lte(9007199254740991).optional(),
    limit: z.int().gt(0).lte(9007199254740991).optional()
});

export const zAdminControllerGetLogsResponse = zAuditLogsPageDto;

export const zCardSideControllerGetSidesResponse = z.array(zCardSideDto);

export const zCardSideControllerCreateSideBody = z.object({
    svg: z.string(),
    name: z.string()
});

export const zCardSideControllerCreateSideResponse = zCardSideDto;

export const zCardSideControllerGetSideSvgPath = z.object({
    id: z.string()
});

export const zCardSideControllerGetSideSvgResponse = zSvgBodyDto;

export const zCardSideControllerDeleteSidePath = z.object({
    id: z.string()
});

export const zCardSideControllerDeleteSideResponse = zDeletedFlagDto;

export const zCardSideControllerRenameSideBody = zRenameSideDto;

export const zCardSideControllerRenameSidePath = z.object({
    id: z.string()
});

export const zCardSideControllerRenameSideResponse = zCardSideDto;

export const zCardTemplateControllerGetTemplatesResponse = z.array(zCardTemplateDto);

export const zCardTemplateControllerCreateTemplateBody = zCreateTemplateDto;

export const zCardTemplateControllerCreateTemplateResponse = zCardTemplateDto;

export const zCardTemplateControllerGetAllTemplatesResponse = z.array(zCardTemplateDto);

export const zCardTemplateControllerGetTemplateSvgPath = z.object({
    id: z.string()
});

export const zCardTemplateControllerGetTemplateSvgResponse = zSvgBodyDto;

export const zCardTemplateControllerGetTemplateSvgsPath = z.object({
    id: z.string()
});

export const zCardTemplateControllerGetTemplateSvgsResponse = zCardTemplateSvgsDto;

export const zCardTemplateControllerDeleteTemplatePath = z.object({
    id: z.string()
});

export const zCardTemplateControllerDeleteTemplateResponse = zDeletedFlagDto;

export const zCardTemplateControllerUpdateTemplateBody = zUpdateTemplateDto;

export const zCardTemplateControllerUpdateTemplatePath = z.object({
    id: z.string()
});

export const zCardTemplateControllerUpdateTemplateResponse = zCardTemplateDto;

export const zDashboardControllerGetResponse = zDashboardDto;
